// extracted by mini-css-extract-plugin
module.exports = {"autofit":"grid-module--autofit--27W3y","autofill":"grid-module--autofill--1b6-2"};